














import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';

@Component({
    components: {},
    mixins: [DialogEventsMixin]
})
export default class CommonPromptDialog extends Mixins<DialogEventsMixin>(DialogEventsMixin) {
    @Prop({default: false}) private readonly loading: boolean;
    @Prop({default: false}) private visible: boolean;
    @Prop({default: false}) private closeOnClick: boolean;
    @Prop({default: false}) private modal: boolean;
    @Prop({default: ''}) private title: string;
    @Prop({default: '30%'}) private width: string;

    private loadingInstance: any;

    get dialogTitle() {
        return this.title;
    }

    get isVisible() {
        return this.visible;
    }

    set isVisible(param) {
        this.visible = false;
    }

    get isLoading() {
        return this.loading;
    }

    get getWidth() {
        return this.width;
    }

    @Watch('loading')
    public watchLoading(loading: boolean) {
        if (loading) {
            this.loadingInstance = this.$loading({target: '.el-dialog'});
        } else {
            this.loadingInstance.close();
        }
    }

    get isCloseOnClick() {
        return this.closeOnClick;
    }

    get isModal() {
        return this.modal;
    }
}
